import { env } from '@sib/config';
import { Api } from './api-client';
import { setDefaultInterceptors } from './interceptors';

const api = new Api({
  baseURL: `${env.apiBaseUrl}/api`,
});

setDefaultInterceptors(api.instance);

export default api;
